import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";
import { format } from "date-fns";

// 🔁 Thunk to fetch notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (userData, { rejectWithValue }) => {
    try {
      let queryString = `&FromDate=${format(new Date(), "yyyy-MM-dd")}&Todate=${format(new Date(), "yyyy-MM-dd")}&Status=${true}`;

      console.log(
        `${Api_EndPoints.GetNotifications}?CompanyCode=${userData?.companyCode}&UserID=${userData?.userID}${queryString}`,
      );

      const { data } = await http_payroll.get(
        `${Api_EndPoints.GetNotifications}?CompanyCode=${userData?.companyCode}&UserID=${userData?.userID}${queryString}
`,
      );

      console.log("data", data);

      return data; // { unreadCount, notifications }
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.message);
    }
  },
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    loading: false,
    error: null,
  },
  reducers: {
    // optional manual update
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
        // state.unreadCount = action.payload.unreadCount;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUnreadCount } = notificationSlice.actions;
export const notificationReducer = notificationSlice.reducer;
export const getNotifications = (state) =>
  state.notifications.notifications;
